import { useAppSelector, useAppDispatch } from "../../app/hooks";
import React, { Fragment, useState } from "react";
import { useHistory } from "react-router-dom";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { sendVoucherRequest, setPhoneNumber } from "../../app/voucherSlice";
import PurchaseSummary from "./PurchaseSummary";
import PurchaseFlowHeader from "../../layout/PurchaseFlowHeader/PurchaseFlowHeader";
import Alert from "../../components/Alerts/Alert";
import Checkbox from "../../components/Checkbox/Checkbox";
import { Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ChooseAmount = () => {
    const { t } = useTranslation();

    const chosenMerchant = useAppSelector(state => state.voucher.chosenMerchant);
    const chosenVoucher = useAppSelector(state => state.voucher.chosenGuid);
    const phoneNumber = useAppSelector(state => state.voucher.phoneNumber);
    const expirationDate = useAppSelector(state => state.voucher.chosenMerchant.minimumExpirationDays);

    const name = chosenMerchant.name;

    const [numberIsValid, setNumberIsValid] = useState(false);
    const [wasTouched, setWasTouched] = useState(false);
    const [expirationIsChecked, setExpirationIsChecked] = useState<boolean>();
    const [redeemIsChecked, setRedeemIsChecked] = useState<boolean>();
    const dispatch = useAppDispatch();
    const history = useHistory();

    const expirationCheckboxHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setExpirationIsChecked(e.target.checked);
    }

    const redeemCheckboxHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setRedeemIsChecked(e.target.checked);
    }

    const submitHandler = (e: React.FormEvent) => {
        e.preventDefault();
        setNumberIsValid(isPossiblePhoneNumber(phoneNumber));

        if (isPossiblePhoneNumber(phoneNumber)) {
            if (
                (expirationDate && !expirationIsChecked) ||
                (chosenMerchant.name === 'DIGin' && !redeemIsChecked) ||
                (chosenMerchant.name === 'A Marmita' && !redeemIsChecked)
            ) {
                setWasTouched(true);
                return;
            }
            dispatch(
                sendVoucherRequest({
                    voucherGuid: chosenVoucher.guid,
                    phoneNumber: parsePhoneNumber(phoneNumber)?.number || '',
                })
            );
            history.replace("/purchase-result");
        } else {
            setWasTouched(true);
        }
    };

    const onPhoneNumberChange = (value: string) => {
        dispatch(setPhoneNumber(value));
    }

    if (!chosenMerchant.id)
        return <Redirect to={"/"} />


    return (
        <section className="container first-section">
            <div className="purchase-container">
                <PurchaseFlowHeader header={t("confirm.title")} />

                <PurchaseSummary
                    icon={chosenMerchant.appIcon}
                    name={chosenMerchant.name}
                    amount={chosenVoucher.amount}
                />

                <hr />
                <p className="confirm__phone">
                    {t("confirm.descriptionFirst")}
                    <span>My Ticket®</span>
                    {t("confirm.descriptionSecond")}</p>
                <form onSubmit={submitHandler}>
                    <PhoneInput
                        className="confirm__phone-number"
                        placeholder={t("confirm.phoneNumberPlaceholder")}
                        value={phoneNumber}
                        defaultCountry="PT"
                        onChange={onPhoneNumberChange}
                    />
                    {wasTouched && !numberIsValid && <Alert message={t("confirm.phoneNumberErrorAlert")} />}

                    {expirationDate &&
                        <Fragment>
                            <Checkbox
                                label={t("confirm.expirationDisclamer", {name, expirationDate})}
                                checkHandler={expirationCheckboxHandler}
                                checkboxType='expiration'
                            />
                        {wasTouched && !expirationIsChecked && <Alert message={t("confirm.checkboxErrorAlert")} />}
                        </Fragment>
                    }

                    {chosenMerchant.name === 'DIGin' &&
                        <Fragment>
                            <Checkbox
                                label={t("confirm.digInDisclamer")}
                                checkHandler={redeemCheckboxHandler}
                                checkboxType='redeem'
                            />
                            {wasTouched && !redeemIsChecked && <Alert message={t("confirm.checkboxErrorAlert")} />}
                        </Fragment>
                    }

                    {chosenMerchant.name === 'A Marmita' &&
                        <Fragment>
                            <Checkbox
                                label={t("confirm.marmitaDisclamer")}
                                checkHandler={redeemCheckboxHandler}
                                checkboxType='redeem'
                            />
                            {wasTouched && !redeemIsChecked && <Alert message={t("confirm.checkboxErrorAlert")} />}
                        </Fragment>
                    }

                    <input
                        type="submit"
                        value={t<string>("confirm.buyVoucher")}
                        className="primary-button w-100 mt-7"
                    />
                </form>
            </div>
        </section>
    );
};

export default ChooseAmount;
